import React, {useEffect, useState} from "react";
import {C} from "../styles";
import Modal from "./Modal";
import {hasSeenMoodPopupToday, markMoodPopupSeenToday} from "../utils";

const MOOD_COLORS = {1: "#E74C3C", 2: "#E67E22", 3: "#F1C40F", 4: "#2ECC71", 5: "#1E6B5E"};

export default function DailyMoodPopup({userId, data, vote}) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (data?.moods && !data.userMood && !hasSeenMoodPopupToday(userId)) {
            markMoodPopupSeenToday(userId);
            setVisible(true);
        }
    }, [data, userId]);

    if (!visible) return null;

    function close() {
        setVisible(false);
    }

    function chooseMood(level) {
        vote(level);
        close();
    }

    return (
        <Modal title="Comment allez-vous aujourd'hui ?" onClose={close}>
            <p style={{margin: "0 0 20px", fontSize: 13, color: C.textMuted, textAlign: "center"}}>
                Un clic suffit — anonyme, ça reste entre vous et votre collectif.
            </p>
            <div style={{display: "flex", justifyContent: "center", gap: 12, flexWrap: "wrap"}}>
                {data.moods.map(m => (
                    <button
                        key={m.level}
                        onClick={() => chooseMood(m.level)}
                        title={m.label}
                        style={{
                            width: 56,
                            height: 56,
                            borderRadius: "50%",
                            border: "none",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 26,
                            background: `radial-gradient(circle at 30% 30%, ${MOOD_COLORS[m.level]}cc, ${MOOD_COLORS[m.level]})`,
                            boxShadow: `0 7px 16px ${MOOD_COLORS[m.level]}73, inset 0 2px 3px rgba(255,255,255,0.5)`,
                            transition: "transform 0.15s",
                        }}
                        onMouseEnter={e => { e.currentTarget.style.transform = "scale(1.12)"; }}
                        onMouseLeave={e => { e.currentTarget.style.transform = "scale(1)"; }}
                    >
                        {m.emoji}
                    </button>
                ))}
            </div>
        </Modal>
    );
}
